import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Linkedin } from "lucide-react";
import ScrollReveal from "@/components/ScrollReveal";

const SOCIAL_LINKS = [
  { href: "https://www.facebook.com/BrilloFinance", icon: Facebook, label: "Facebook" },
  { href: "https://www.instagram.com/brillofinance", icon: Instagram, label: "Instagram" },
  { href: "https://www.linkedin.com/company/brillofinance", icon: Linkedin, label: "LinkedIn" },
];

export default function Footer() {
  return (
    <footer
      className="border-t"
      style={{ borderColor: "rgba(255,255,255,0.06)", background: "#1F1F1F" }}
      data-testid="footer-section"
    >
      <div className="bf-container py-12 md:py-16">
        <ScrollReveal preset="fadeUp" duration={0.7} threshold={0.2}>
          <div className="grid md:grid-cols-2 gap-10 md:gap-16">
            {/* Left – Brand + Legal */}
            <div>
              <p
                className="text-xs tracking-wider"
                style={{ color: "rgba(255,255,255,0.4)" }}
              >
                Brillo Finance® · Arquitectura de Capital · Franquicia Creditaria Deluxe ·{" "}
                <a
                  href="https://brillofinance.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bf-link"
                  style={{ color: "rgba(255,255,255,0.55)" }}
                >
                  brillofinance.com
                </a>
              </p>
              <p
                className="mt-4 text-[11px] leading-relaxed max-w-md"
                style={{ color: "rgba(255,255,255,0.18)" }}
              >
                Intermediario financiero, no institución otorgante. CAT informativo
                sin IVA. Condiciones sujetas a cada institución. Sujeto a
                aprobación crediticia.
              </p>
            </div>

            {/* Right – Address + Phone + Social */}
            <div className="md:text-right">
              <p
                className="text-xs leading-relaxed"
                style={{ color: "rgba(255,255,255,0.4)" }}
                data-testid="footer-address"
              >
                Av. Américas 1421 Piso 11. Torre Helix.
                <br />
                Providencia. Guadalajara, Jalisco. C.P. 44630
              </p>
              <p className="mt-3">
                <a
                  href="tel:+523344065965"
                  className="text-xs tracking-wider bf-link"
                  style={{ color: "rgba(255,255,255,0.55)" }}
                  data-testid="footer-phone"
                >
                  33 4406 5965
                </a>
              </p>
              <div className="mt-5 flex items-center gap-5 md:justify-end" data-testid="footer-social-links">
                {SOCIAL_LINKS.map((s) => (
                  <a
                    key={s.label}
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={s.label}
                    className="transition-colors duration-300"
                    style={{ color: "rgba(255,255,255,0.3)" }}
                    onMouseEnter={(e) => (e.currentTarget.style.color = "var(--teal)")}
                    onMouseLeave={(e) => (e.currentTarget.style.color = "rgba(255,255,255,0.3)")}
                  >
                    <s.icon className="h-[18px] w-[18px]" strokeWidth={1.5} />
                  </a>
                ))}
              </div>
              <div className="mt-4">
                <Link
                  to="/login"
                  data-testid="footer-admin-link"
                  className="text-[10px] uppercase tracking-[0.2em] transition-colors duration-300 bf-link"
                  style={{ color: "rgba(255,255,255,0.15)" }}
                  onMouseEnter={(e) => (e.currentTarget.style.color = "rgba(255,255,255,0.4)")}
                  onMouseLeave={(e) => (e.currentTarget.style.color = "rgba(255,255,255,0.15)")}
                >
                  Administrador
                </Link>
              </div>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </footer>
  );
}
